import * as types from './mutation-types';

export default {
  showSocialPostDialog({ commit, dispatch }, post) {
    if (post && post.id) {
      dispatch('social/editingPost', post, { root: true });
    } else {
      dispatch('social/creatingPost', post, { root: true });
    }
    commit(types.SHOW_SOCIAL_POST_DIALOG);
  },

  hideSocialPostDialog({ commit }) {
    commit(types.HIDE_SOCIAL_POST_DIALOG);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/modals/actions.js